import { useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function useNavigateKeepSearchParams(
  paramsToKeep: Array<string> | null = null,
) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  return useCallback(
    (path: string) => {
      const targetUrl = new URL(path, window.location.origin);
      const newSearchParams = new URLSearchParams(targetUrl.searchParams);
      searchParams.forEach((value, key) => {
        if (paramsToKeep === null || paramsToKeep.includes(key)) {
          newSearchParams.set(key, value);
        }
      });
      const newTarget =
        newSearchParams.size > 0
          ? `${path.split("?")[0]}?${newSearchParams}`
          : path;
      navigate(newTarget);
    },
    [navigate, paramsToKeep, searchParams],
  );
}
